// Room belongs to the whole surface span. Only the idle picker makes this decision; ability
// drawing and explicit preview commands are unchanged. Unknown room takes the old path.
import { IDLE_REACH } from './idle-reach-data.js';
import { cast, heightOf, scaleOf } from './companion.js';
import { env } from './core.js';
import { baseOf } from './travel.js';
import { hatHeight } from './outfits.js';

export function idleFitsRoom(me, id) {
  const q = me.anchor && baseOf(me.anchor)?.geom();
  if (q?.room == null) return true;
  const reach = IDLE_REACH[me.design.id]?.[id];
  // No measurement (including a newly added idle), or a branch requiring other surfaces:
  // leave it to dwell's small fidgets until the table has a safe envelope for this context.
  if (!reach || !reach.local || !['stand', 'sit'].includes(me.anchor.rest)) return false;
  if (reach.solo && cast.some(o => o !== me && o.alpha > 0 && !o.atHome)) return false;
  // Shared hats are extra geometry above the recorded looks. A full hat height in every
  // direction is conservative even when the body rotates. Own skin hats are recorded too.
  const hat = hatHeight(me.outfit.head === 'none' ? me.look.wear?.head : me.outfit.head, me.pose.capDown);
  // Some summoned props/puppets use the screen's scale or the companion's unshrunk scale.
  // Text spots can shrink its current s; the larger scale keeps those drawings covered too.
  const s = Math.max(me.s, env.S, scaleOf(me));
  return Math.max((reach.up + hat) * s, heightOf(me)) <= q.room
    && me.x - (reach.left + hat) * s >= q.x1
    && me.x + (reach.right + hat) * s <= q.x2;
}
